type Props = {
  className?: string
}

export default function IconLogout({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 124 124"
      fill="none"
      className={className}>
      <path
        fill="currentColor"
        d="M107.9-.5h-52.4c-8.48.01-15.37,6.93-15.36,15.4v29.36c0,2.49,2.01,4.5,4.5,4.5s4.5-2.01,4.5-4.5V14.9c0-1.71.66-3.31,1.86-4.52s2.81-1.87,4.5-1.88h52.41c1.71,0,3.31.67,4.51,1.88,1.2,1.21,1.86,2.81,1.86,4.53v94.2c0,3.52-2.86,6.38-6.38,6.38h-52.39c-3.51,0-6.37-2.87-6.37-6.38v-30.63c0-2.49-2.01-4.5-4.5-4.5s-4.5,2.01-4.5,4.5v30.63c0,8.47,6.89,15.37,15.37,15.38h52.4c8.48,0,15.38-6.9,15.38-15.38V14.92c0-4.11-1.58-7.98-4.48-10.89-2.9-2.91-6.76-4.52-10.9-4.53Z"
      />
      <path
        fill="currentColor"
        d="M16.08,66.5h64.52c2.49,0,4.5-2.01,4.5-4.5s-2.01-4.5-4.5-4.5H16.08l14.09-14.09c1.76-1.76,1.76-4.61,0-6.36-1.76-1.76-4.61-1.76-6.36,0L2.03,58.82c-1.76,1.76-1.76,4.61,0,6.36l21.77,21.78c.88.88,2.03,1.32,3.18,1.32s2.3-.44,3.18-1.32c1.76-1.76,1.76-4.61,0-6.36l-14.09-14.09Z"
      />
    </svg>
  )
}
